module.exports = __webpack_public_path__ + "img/Veien-til-verdens-ende_Bilde-fra-kontoret.099777c5.jpg";